import { Injectable } from '@angular/core';
import { combineLatest, EMPTY, merge, Observable, Subject } from 'rxjs';
import { Persona } from '@app/persona/models';
import { select, Store } from '@ngrx/store';
import { getPersonaEntities, getSelectedPersona, State } from '@app/persona/store';
import { catchError, map, shareReplay, take } from 'rxjs/operators';
import { SetPersona } from '@app/persona/store/personas/persona.actions';

@Injectable({
    providedIn: 'root'
})
export class PersonaPickerService {

    selectedPersona$: Observable<Persona>;
    toSelectPersona$: Observable<Persona>;
    toSelectedPersonaId$ = new Subject<number>();
    hasToSelectPersona$: Observable<boolean>;

    setToSelectPersona(organisationGroupId: string) {
        this.toSelectedPersonaId$.next(+organisationGroupId);
    }

    setPersona(persona: Persona) {
        this.store.dispatch(new SetPersona(persona));
    }

    private getSelectedPersona$() {
        return this.store.pipe(
            select(getSelectedPersona),
            shareReplay({ bufferSize: 1, refCount: false })
        );
    }

    private getToSelectPersona$() {
        const toSelect$ = combineLatest([
            this.store.pipe(select(getPersonaEntities)),
            this.toSelectedPersonaId$
        ]).pipe(
            map(([items, organisationGroupId]) => {
                if (!organisationGroupId) {
                    return null;
                }

                const personaFromState = items[organisationGroupId];
                if (!!personaFromState) {
                    return personaFromState;
                }
                return { organisationGroupId, name: '', type: 'persona', personaOrganisationGroupIds: [organisationGroupId] };
            })
        );

        return merge(
            this.selectedPersona$.pipe(take(1)),
            toSelect$
        ).pipe(
            shareReplay({
                bufferSize: 1,
                refCount: false
            }),
            catchError(e => {
                console.error(e);
                return EMPTY;
            })
        );

    }

    private getHasToSelectPersona$() {
        return combineLatest([
            this.toSelectPersona$.pipe(map(item => !!item ? item.organisationGroupId : null)),
            this.selectedPersona$.pipe(map(item => !!item ? item.organisationGroupId : null))
        ]).pipe(
            map(([toSelect, selected]) => toSelect !== selected),
            shareReplay({
                bufferSize: 1,
                refCount: false
            }),
        );

    }

    constructor(private store: Store<State>) {
        this.selectedPersona$ = this.getSelectedPersona$();
        this.toSelectPersona$ = this.getToSelectPersona$();
        this.hasToSelectPersona$ = this.getHasToSelectPersona$();
    }

}

